import script from "./ProtocolAndPolicy.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProtocolAndPolicy.vue?vue&type=script&lang=ts&setup=true"

import "./ProtocolAndPolicy.vue?vue&type=style&index=0&id=91db01ac&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91db01ac"]])

export default __exports__